<script>
  export default {
    props: ['relatorio', 'projeto', 'dataInicio', 'dataFim'],
    methods: {
      saldo(rubrica, indice) {
        if (rubrica.lancamentos === null) return 0;
        
        return rubrica.saldoAnterior + 
          rubrica.lancamentos.reduce((total, lancamento, indiceLancamento) => {
            if (indiceLancamento > indice) return total;
            
            return this.somaOuSubtraiSaldo(total, lancamento.creditoDebito, lancamento.valorRateio);
          }, 0);
      },
      somaOuSubtraiSaldo(total, creditoDebito, valor) {
        if (creditoDebito === 1) {
          return total + valor;
        } else {
          return total - valor;
        }
      }
    },
    computed: {
      saldoAnterior() {
        let total = 0;

        this.relatorio.forEach(metaEtapa => {
          total += Object.keys(metaEtapa).reduce((totalRubrica, chave) => {
            return totalRubrica + metaEtapa[chave][0].saldoAnterior +  
              (metaEtapa[chave][0].lancamentos || []).reduce((totalLancamento,  lancamento) => {
                return this.somaOuSubtraiSaldo(totalLancamento, lancamento.creditoDebito, lancamento.valorRateio);
              }, 0);
          }, 0);
        });
        
        return total;
      }
    }
  }
</script>

<template>
  <div>

    <div class="table-responsive">
      <table class="table table-condensed no-margins">
        <thead>
          <tr>
            <th>Projeto</th>
            <th class="text-right">Período</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ projeto.nomeProjeto }}</td>
            <td class="text-right">{{ dataInicio }} - {{ dataFim }}</td>
          </tr>
        </tbody>
      </table>

      <table class="table relatorio table-bordered no-margin-bottom" v-for="metaEtapa in relatorio">
        <thead>
          <tr v-if="projeto.utilizarMetaEtapaProjeto">
            <th colspan="8"><b>{{ metaEtapa[Object.keys(metaEtapa)[0]][0].metaEtapa }}</b></th>
          </tr>
          <tr>
            <th colspan="2">Rubrica</th>
            <th class="text-right">Valor total</th>
            <th class="text-right">Valor repassado</th>
            <th class="text-right">Saldo anterior</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="rubrica in metaEtapa">
            <tr>
              <td colspan="2">{{ rubrica[0].nomeRubrica }}</td>
              <td class="text-right" style="width: 180px">{{ rubrica[0].valorTotal | formatarNumero }}</td>
              <td class="text-right" style="width: 180px">{{ rubrica[0].valorRepassado | formatarNumero }}</td>
              <td class="text-right" style="width: 180px">{{ rubrica[0].saldoAnterior | formatarNumero }}</td>
            </tr>
            <tr v-if="rubrica[0].lancamentos != null">
              <td><b>Data</b></td>
              <td><b>Hitorico</b></td>
              <td class="text-center"><b>CD</b></td>
              <td class="text-right"><b>Valor</b></td>
              <td class="text-right"><b>Saldo</b></td>
            </tr>
            <tr v-if="rubrica[0].lancamentos != null" v-for="(lancamento, indice) in rubrica[0].lancamentos">
              <td>{{ lancamento.data | formatarData }}</td>
              <td>{{ lancamento.historico + ' - '+ lancamento.nomeSubrubrica }}</td>
              <td class="text-center">{{ lancamento.creditoDebito === 1 ? 'C' : 'D' }}</td>
              <td :class="['text-right', lancamento.creditoDebito === 1 ? 'text-primary' : 'text-danger']">
                {{ lancamento.valorRateio | formatarNumero }}
              </td>
              <td :class="['text-right', saldo(rubrica[0], indice) >= 0 ? 'text-primary' : 'text-danger']">
                {{ saldo(rubrica[0], indice) | formatarNumero }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      
      <table class="table relatorio table-bordered no-margin-bottom">
        <tbody>
        <tr>
          <td colspan="4">&nbsp;</td>
        </tr>
          <tr>
            <td class="text-right bg-muted"><b></b></td>
            <td class="text-right bg-muted" style="width: 180px"><b>Valor total</b></td>
            <td class="text-right bg-muted" style="width: 180px"><b>Valor repassado</b></td>
            <td class="text-right bg-muted" style="width: 180px"><b>Saldo anterior</b></td>
          </tr>
          <tr>
            <td class="text-right"><b></b></td>
            <td class="text-right"><b>{{ 0 | formatarNumero }}</b></td>
            <td class="text-right"><b>{{ 0 | formatarNumero }}</b></td>
            <td class="text-right"><b>{{ saldoAnterior | formatarNumero }}</b></td>
          </tr>
        </tbody>
      </table>
    </div>
        
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/acesso-especial/relatorio/componentes/Rubricas/Analitico.vue